// extracted by mini-css-extract-plugin
module.exports = {"container":"-zhp44xIoaDbCuMbjucBZ","badge":"_2MtdwHpXdCRG_m9I8bnRcP"};